// extracted by mini-css-extract-plugin
export default {"button":"AiPhotoGenerationButtonSave__button--39S8z"};